import React from 'react';
import { makeStyles } from '@mui/styles';
import Box from "@mui/material/Box";
import AccountOrder from "../AccountOrder";
import AccountPlanCurrent from "../AccountPlanCurrent";

const useStyles = makeStyles((theme) => ({
    root: {},
    title: {
        background: '#ececec',
        padding: '5px'
    }
}));

export default function OnlineStatus({plan}) {
    const classes = useStyles();
    return (
        <Box className={classes.root} pb={2}>
            {/*<Box mb={2}>*/}
            {/*    <FollowingCustomer />*/}
            {/*</Box>*/}
            <Box mb={2}>
                <AccountPlanCurrent />
            </Box>
            <Box mb={2}>
                <AccountOrder />
            </Box>
        </Box>
    )
}